import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Fun with cheap iPhone lenses",
  "description": "",
  "published": "2012-07-05T00:00:00.000Z",
  "redirect_from": ["/blog/fun-with-cheap-iphone-lenses/swizec/4782"],
  "categories": "Fisheye lens, IPhone, Kit lens, Macrophotography, Personal, Telephoto lens, Travel + Events, Wide-angle lens, Zurich",
  "hero": "./img/tumblr_m6osxdwjBO1qekjngo1_500.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/zurich-river-fisheye-1024x764.jpg",
        "alt": "Zurich river fisheye",
        "title": "Zurich river fisheye"
      }}></img></p>
    <p>{`Two weeks ago I ordered a set of `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone",
        "title": "iPhone"
      }}>{`iPhone`}</a>{` lenses on ebay. They looked cheap enough (only 30 euro) and hey, I take plenty of pictures with my phone. Why not add a little extra?`}</p>
    <p>{`And I really wanted the tele-lens.`}</p>
    <p>{`For the same price of that tele-lens from the official seller, you can get:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f0c18c42c0d70ce12093e32c0af1e967/41099/tumblr_m6osxdwjBO1qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2042v42l2%201c4%201%205%200%203-3-3-3-3-3%201-3%202%200%202%200%201%201s0%201%204%201c6-1%208-2%206-4l-1-5-1-4v-4l1%202h2c1-2%201-3-1-4-3-2-2-3%204-3s12-2%206-2c-3%200-6-3-4-5l1%201%201%201v-1c-2-2-1-3%203-2l4-1%202-1v-1l-2-1%201-1c2%201%207%200%207-2l4-1c3%201%204%201%204-1l2-1c3%201%205%200%203-1-1-1%200-1%202-1s3%200%203-2%200-2%205-2h2c-4-2-4-3%203-2%205%200%206%200%206-2l1-1%201%201c-1%201%200%201%201%201l2-1%202-1c2%200%203%200%204-2%200-3%203-4%203-1%200%202%200%202%204%201l2-1h-2c-2%200-2%200%200-1l4-1%201-1%204-2c2%200%202%200%201-2-5-5-5-9-1-9%2018%200%2020%200%2020-2h4c0-2-1-2-4-2h-2c1-2%209-1%209%201l1%201%201-1c-1-1%201-2%206-3l18-1%2016-1%204%201h10a369%20369%200%200163%204c-1%201%201%202%203%201s5-1%209%201l5%202-1-3V8c1%200%202%201%202%203%201%202%201%202%202%201%202-1%207%201%209%204l16%204%204%201-2%201c-3%200-3%202%201%203l4%202c0%201%201%202%203%202l4%201c1%202%202%202%204%202%202-1%202%200%202%202%200%203%202%203%203%200%200-2%200-2%202%200l2%202h3l1%201c-1%201%202%204%205%204%203%201%203%201%202%203%200%202%200%202%203%202l4%201%202%201c2%200%202%200%201%201s7%204%2011%204l1%202v3c0%202%200%202%207%202l7%201-4%201h-2l2%203%202%204c-2%202-1%204%201%204h12l-4%201c-5%202-4%203%201%203l5%202c1%201%201%201-1%201h-2l3%202%202%201c-1%201-1%201%201%202%201%201%201%201-1%202-3%200-3%203%201%203l-2%201-8%202h-7c-17-3-40%200-55%209l-13%205a15508%2015508%200%2000-112%2022v3l2%207v4l-4-5-1-2c2%200%202%200%201-1l-1-4-1-2c-2%200-3%202-1%202l1%202c-1%203-5%201-7-3-2-6-4-7-9-6h-6c-2-2-7-1-10%201h-3c-3-3-7-2-5%201%201%201%200%202-2%204l-2%202-1-2c0-3-2-4-2-1l-2%202-6%201c-4%201-4%202-3%204%200%203%200%203-3%204-5%200-6%203-6%2010l1%206H98l-2-1-2-2-5-7-3-7c0-2-1-2-4-2-5%200-4%200-4%209%200%208%200%209-2%209l-2-1a245%20245%200%2000-18-45c0-4-7-1-8%204-1%202%201%201-30%206l-17%203-1%2014v15h2a1138%201138%200%200148-8c3-1%203-1%204%203l13%2056c0%202-7%204-18%205a346%20346%200%2000-39%207l-10%201v36l6-2c4%200%209-2%2011-4l9-3%206-2%205-1%205-1c0-1%201-2%203-2l3-1%2013-3%208-2%2010-3%209-3%207-2%202-2%202-1%202-1%202-1%201-1h1l2-2%205-3%204-2%202-1c1%200%207-5%207-7l-2-1h-3c-7-1-12-4-15-9-2-3-2-3%201-5%201-2%204-3%205-3%203-1%204-3%202-3v-1c1-2%202-2-8-2l-7-1c-1-1%204-6%208-7l4-1h7l2%204c1%207%204%209%2010%208%2014-2%2016-2%2016%200%201%203%200%204-2%204l-1%202-1%204%201%202%204%202c2%203%206%203%206%200%200-2%201-2%203-2l10-2%2011-1c6%201%207-1%201-2-3%200-3%200-1-1h6c3%201%205%201%204-1l3-1%202%201v1h1c0-3%203-3%2010-2%207%200%209%200%205-2-2-1-1-1%204-1%2010%200%2011%200%209-1-1-1-1-1%2011-2%206%200%206%200%205-1l5-1c5%201%2012%200%2013-2l3-1c8%201%2012%200%2012-1-1-2%200-2%204-2l8-1%206-1%204-1v11c1%209%201%2013%203%2016%202%205%202%206%200%206l-1%202v7c-1%203-1%205%201%2010s2%209%203%2031c0%2029%201%2031%2011%2041%207%207%2019%2011%2040%2013l6%201h12l11-1c9%200%2010%200%2011%202l1%202%201-1c-2-2%200-3%202-1l4%204c4%202%204%204%201%204s-5%202-3%203l2%202%201%201%202%202c1%202%201%202%201%200l-1-4v-1l1-52a1331%201331%200%2000-1-46c2%202%201%203-3%203h-6l1-2v-6c1-3%204-4%206-2s3%201%203-5c0-3%200-4-1-3l-1%202v1c0%202-2%203-4%202-1%200-2-1-1-2l2-10%204-17%202-94V0H0v42m296%20127c0%202%208%2010%2013%2013a43%2043%200%200026%207c-13-3-26-10-34-17l-5-3m-108%2053c-22%207-26%2029-8%2038%2013%206%2031%202%2039-9%202-4%203-5%203-11%200-8-3-12-12-16-4-2-18-4-22-2m-99%205c-11%204-17%2011-16%2019%201%205%202%207%2010%2010%207%203%2013%203%2020%201%209-4%2016-12%2016-19%200-11-17-17-30-11m139%2014l-1%209-1%205c-1%206-2%208-6%2010-3%202-7%206-7%209-1%202-1%202%202%202l4-3%202-1%202-1c1-1%202-2%203-1l2-1%209-2c6-1%208-2%208-3-1-1%201-2%205-1%202%200%204%200%205-2l4-2c3%200%2013-8%2013-11l1-1c3-1%200-6-5-8-6-2-26-4-28-2-3%202-11%202-11%200-1-1-1%201-1%204m-96-3l-6%201h-3l-1%204-3%2010-2%208-3%205c-3%203-2%204%202%201a212%20212%200%200130-15c-1-2%200-3%203-3%202%200%202%200%201-1s-1-1%201-1c2-1%203-2%203-4%200-5-8-7-22-5m257%2088c-1%200-3%201-3%203-1%203-1%203%201%203l1%201-2%201c-3%200-3%201%200%203l2%203v4c-3%200-2%202%200%203%202%202%203%204%201%206v4c-1%202-4%200-4-1%201-1%200-2-1-3s-1-1-2%201c0%203-8%205-10%203-1-3-2-2-2%200%200%201%201%202%203%202%2012%201%2013%201%2013%204l2%203%201%201%202%203c3%203%203%206%200%206-2%200-2%200-1-1%201-2%201-2-1-4-2-1-2-1-1-2%201%200%201-1-1-2s-2-1-4%201l-2%202-3%202c-2%202-2%202-2-1s0-3-5-2c-2%202-3%202-3%201l3-3c4-1%204-2%201-3l-3%201-1%202c-3%200-3%201-1%203l1%204-7%203h-1l1%202%201%202%202%202c2%200%201%202-1%201l-2%201c0%201%201%202%203%202l3%203c1%201%201%201%202-1%201-3%202-2%201%201-1%205-3%207-5%205-4-1-9%200-8%202%201%201%201%201-3%201l-5-2-5-1h-3l3%201%203%203%208%201c5%200%207%200%206-1l-2-1c0-1%201-1%207%201%203%201%203%201%205-1l4-3%201-1c0-2%203-1%206%201%202%202%203%203%201%203l-2-1-1-1-1%202c0%202%201%202%2011%202h10v-7l-1-6v-4l1-27v-27h-3l-2-1h2l3-1c0-2-5-2-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f0c18c42c0d70ce12093e32c0af1e967/ca0a1/tumblr_m6osxdwjBO1qekjngo1_500.webp 223w", "/static/f0c18c42c0d70ce12093e32c0af1e967/75680/tumblr_m6osxdwjBO1qekjngo1_500.webp 445w", "/static/f0c18c42c0d70ce12093e32c0af1e967/b0a15/tumblr_m6osxdwjBO1qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f0c18c42c0d70ce12093e32c0af1e967/853b2/tumblr_m6osxdwjBO1qekjngo1_500.jpg 223w", "/static/f0c18c42c0d70ce12093e32c0af1e967/0a4fe/tumblr_m6osxdwjBO1qekjngo1_500.jpg 445w", "/static/f0c18c42c0d70ce12093e32c0af1e967/41099/tumblr_m6osxdwjBO1qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f0c18c42c0d70ce12093e32c0af1e967/41099/tumblr_m6osxdwjBO1qekjngo1_500.jpg",
                "alt": "The lens kit",
                "title": "The lens kit",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The lens kit`}</figcaption>{`
  `}</figure></p>
    <ul>
      <li parentName="ul">{`a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Macrophotography",
          "title": "Macrophotography"
        }}>{`macro lens`}</a></li>
      <li parentName="ul">{`a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Fisheye_lens",
          "title": "Fisheye lens"
        }}>{`fish eye lens`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Telephoto_lens"
        }}>{`telelens`}</a></li>
      <li parentName="ul">{`a tripod`}</li>
      <li parentName="ul">{`a baggy to hold everything`}</li>
    </ul>
    <p>{`It's one of those deals that's almost too good to be legal ... and I did receive everything without perfectly original packaging. But it looked new and unused.`}</p>
    <h2 {...{
      "id": "the-verdict"
    }}>{`The verdict`}</h2>
    <p>{`Last week's sightseeing in Zurich offered the perfect opportunity to test everything out.`}</p>
    <p>{`I am in love!`}</p>
    <p>{`Despite some failings in practicality this is a really awesome kit and I suggest anyone who's bored with their photos but too lazy to get a real camera to go ahead and buy this.`}</p>
    <p>{`The biggest surprise is definitely the fish eye lens. I thought it was going to be useless, I mean didn't those mostly die out with the lowering popularity of home made skate movies in the naughties? And the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Normal_lens",
        "title": "Normal lens"
      }}>{`normal lens`}</a>{` is already plenty wide-angled!`}</p>
    <p>{`Well guess what, for taking pictures of rooms - something I do very often - or taking pictures of landmarsk, the fish eye is practically indispensable because it's the only way to get everything into the picture.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/zurich-river-300x224.jpg",
        "alt": "Zurich river normal",
        "title": "Zurich river normal"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/zurich-river-fisheye-300x224.jpg",
        "alt": "Zurich river fisheye",
        "title": "Zurich river fisheye"
      }}></img></p>
    <p>{`Unfortunately I'm somewhat disappointed by the tele-lens. It's the main reason I even bought the kit, but it turns out to be practically useless. It zooms too much and it's almost impossible to get a decent shot of anything. Plus it can't even focus on anything closer than 3 meters.`}</p>
    <p>{`The extensive zoom also means taking sharp pictures is near impossible without the tripod, which is very impractical for my point and shoot style of photography. There's also a lot more blurring around the edges than I originally anticipated (despite knowing about this problem)`}</p>
    <p>{`However, if you need to highlight anything - this lens is your man!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/pretty-house2-e1341492265181-300x224.jpg",
        "alt": "A pretty house",
        "title": "A pretty house"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/pretty-house-telelens-300x224.jpg",
        "alt": "Telelens can't get the whole house ..",
        "title": "Telelens can't get the whole house .."
      }}></img></p>
    <p>{`The macro lens is pretty fun as well although I don't often take macro photos. Well, to be honest, I've taken about two or three macro photos in my life, but when the urge hits me next - the lens is right there! Ready to step up to the challenge and make things awesome.`}</p>
    <p>{`Bloody fascinating how up close and personal you can shove the lens and still be able to focus though.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/macro-lens-e1341492483119-764x1024.jpg",
        "alt": "A macro tomato plant",
        "title": "A macro tomato plant"
      }}></img></p>
    <p>{`All in all, I have to say I'm very pleased with the lenses I got. Especially at this price.`}</p>
    <p>{`Not going to win me any photography awards any time soon, but they do open a whole new space of possibilities that simply didn't exist before.`}</p>
    <p>{`PS: Zurich's got a sort of beach about a 5 minute walk out of city center. If you're visiting in the summer, bring a swimsuit.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/07/zurich-beach.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/07/zurich-beach-e1341492660981-1024x764.jpg",
          "alt": "Zurich beach",
          "title": "Zurich beach"
        }}></img></a></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cellularaddons.com/2012/05/ipro-lens-system-for-apple-iphone-4-4s-with-cases-handle-fisheye-wide-angle-lenses/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_08_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cellularaddons.com/2012/05/ipro-lens-system-for-apple-iphone-4-4s-with-cases-handle-fisheye-wide-angle-lenses/"
        }}>{`iPro Lens System for Apple iPhone 4 & 4S with Cases, Handle, Fisheye & Wide-Angle Lenses`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blackrockstar.wordpress.com/2012/05/14/gizmon-ipad-iphone-clip-on-lenses/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/88775801_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blackrockstar.wordpress.com/2012/05/14/gizmon-ipad-iphone-clip-on-lenses/"
        }}>{`Gizmon IPad & IPhone Clip-On Lenses`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://abcnews.go.com/Technology/iphone-camera-accessories-best-iphone-lenses-flashes-tripods/story?id=16268582"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/87114828_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://abcnews.go.com/Technology/iphone-camera-accessories-best-iphone-lenses-flashes-tripods/story?id=16268582"
        }}>{`Best iPhone Camera Accessories`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thespendicate.typepad.com/my-blog/2012/05/nerd-buy-olloclip.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/89018402_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://thespendicate.typepad.com/my-blog/2012/05/nerd-buy-olloclip.html"
        }}>{`Nerd Buy: Olloclip`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://9to5mac.com/2012/06/20/olloclip-for-iphone-camera-lens-kit-review/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95428104_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://9to5mac.com/2012/06/20/olloclip-for-iphone-camera-lens-kit-review/"
        }}>{`Olloclip for iPhone camera lens kit review`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=7026883d-8d63-477f-839a-81d68b894a0f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      